import { EventEmitter } from '@angular/core';
import { BenchmarkPerformanceReportData, ReportSectionEnum } from '../../../../../models/measure/report';
import { CommonConstant } from '../../../../app.constants';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
var BenchMarkStatusEnum;
(function (BenchMarkStatusEnum) {
    BenchMarkStatusEnum["ASCENDING"] = "asc";
    BenchMarkStatusEnum["DESCENDING"] = "desc";
})(BenchMarkStatusEnum || (BenchMarkStatusEnum = {}));
var AverageBenchmarkPerformanceReportComponent = /** @class */ (function () {
    function AverageBenchmarkPerformanceReportComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.changeBenchmarkPerformanceSettings = new EventEmitter();
    }
    AverageBenchmarkPerformanceReportComponent.prototype.ngOnInit = function () {
        this.isNoData = false;
        if (this.data && this.data.length === 0) {
            this.isNoData = true;
            return;
        }
        // get industry list
        if (this.data) {
            this.industryList = this.data
                .map(function (channel, index) { return ({
                id: index,
                name: channel.menu.nameRight
            }); })
                .filter(function (channel) { return channel.name !== CommonConstant.NA_VALUE; });
            if (this.industryIndex) {
                this.selectIndustry(this.industryIndex);
            }
            else if (this.industryList.length > 0) {
                this.industryIndex = this.industryList[0].id;
                this.selectIndustry(this.industryIndex);
            }
        }
    };
    AverageBenchmarkPerformanceReportComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(AverageBenchmarkPerformanceReportComponent.COMPONENT_NAME);
    };
    AverageBenchmarkPerformanceReportComponent.prototype.selectIndustry = function (industryIndex) {
        if (industryIndex === null) {
            this.benchmarkData = new BenchmarkPerformanceReportData();
        }
        else {
            this.benchmarkData = this.data[industryIndex];
            this.changeBenchmarkPerformanceSettings.emit({
                reportType: ReportSectionEnum.INSIGHT_BENCHMARK_REPORT,
                value: industryIndex
            });
        }
    };
    // calculate percent and return if percent is bigger than 100
    AverageBenchmarkPerformanceReportComponent.prototype.calculatePercent = function (percent, status) {
        var result = percent > 100 ? 50 : percent / 2;
        if (status === BenchMarkStatusEnum.ASCENDING) {
            this.leftPercent = 50 - result;
        }
        else {
            this.leftPercent = 50;
        }
        return Math.abs(result);
    };
    AverageBenchmarkPerformanceReportComponent.prototype.isImpactType = function (item) {
        return item === CommonConstant.BENCHMARK_IMPACT;
    };
    AverageBenchmarkPerformanceReportComponent.prototype.isAscending = function (item) {
        return item === BenchMarkStatusEnum.ASCENDING;
    };
    Object.defineProperty(AverageBenchmarkPerformanceReportComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    AverageBenchmarkPerformanceReportComponent.prototype.chartColorByStatus = function (item) {
        return this.isAscending(item.status) ? this.userService.chartColors[CommonConstant.GREEN_COLOR_INDEX] : this.userService.chartColors[CommonConstant.RED_COLOR_INDEX];
    };
    AverageBenchmarkPerformanceReportComponent.COMPONENT_NAME = 'AverageBenchmarkPerformanceReportComponent';
    return AverageBenchmarkPerformanceReportComponent;
}());
export { AverageBenchmarkPerformanceReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/average-benchmark-performance-report/average-benchmark-performance-report.component.ts.pre-build-optimizer.js